
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHeavySleetShowersPolartwilightColour as ObiHeavySleetShowersPolartwilightColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-heavy-sleet-showers-polartwilight-colour.js';
 
 
 

 
 export const ObiHeavySleetShowersPolartwilightColour = createComponent({
   react: React,
   tagName: 'obi-heavy-sleet-showers-polartwilight-colour',
   elementClass: ObiHeavySleetShowersPolartwilightColourElement,
   events: {
     
   }
  });
 
 